/* eslint-disable check-file/filename-naming-convention */
import type { TournFlags2 } from '@ps/web-poker-types';
import BitSet from 'bitset';

export default function is64BitFlagSet(tournFlags2: number, flag: TournFlags2) {
  const bit = Math.log2(flag);
  const hexMask = Number(tournFlags2).toString(16);
  const flagMask = BitSet.fromHexString(hexMask);
  return !!flagMask.get(bit);
}
